<template>
	<div>
		<div style="width: 90%;text-align: left;" class="center_sun">
			<br /><br /><br />
			<div v-show="this.$i18n.locale == 'zh'" v-html="data.text"></div>
			<div v-show="this.$i18n.locale == 'en'" v-html="data.text1"></div>
			
			<hr style="margin-bottom: 50px;"/>
			
			<div style="color: white;">	
				<h2>{{ $t('lang.News1')}}</h2>
				<div v-show="this.$i18n.locale == 'zh'" >
						<div style="margin: 12px 0px;" v-for="item in more" :key = "item.id" v-on:click='handle1(item.id)'>
							<i style="color: #b66a1b;">{{item.title}}</i>
						</div>
				</div>
				<div v-show="this.$i18n.locale == 'en'" style="margin: 20px 0px;">
						<div style="margin: 12px 0px;" v-for="item in more" :key = "item.id" v-on:click='handle1(item.id)'>
								<i style="color: #b66a1b;">{{item.titleEn}}</i>
						</div>
				
				</div>
				<br /><br /><br /><br /><br /><br />
			</div>
			
			<div style="clear: both;"></div>
			
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data : "",
			more : "",
		};
	},
	created(){
		this.handle();
		this.morenews();
	},
	methods:{
		handle : function(){
			console.log(this.$route.query.id);
			var id = this.$route.query.id
			var url = this.baseUrl+"news/find_news";
			this.axios({
				// 默认请求方式为get
				method: 'get',
				url: url,
				// 传递参数
				params: {
					id : id,
				},
			}).then(response => {
				// 请求成功
				console.log(JSON.stringify(response.data));
				this.data = response.data.data;
			}).catch(error => {
				// 请求失败，当then种出错就进入这里
				console.log("请求失败"+JSON.stringify(error));
				
			});
		},
		morenews : function(){
			var url = this.baseUrl+"news/find_random_news";
			this.axios({
				// 默认请求方式为get
				method: 'get',
				url: url,
			}).then(response => {
				// 请求成功
				console.log(JSON.stringify(response.data));
				this.more = response.data.data;
			}).catch(error => {
				// 请求失败，当then种出错就进入这里
				console.log("请求失败"+JSON.stringify(error));
				
			});
		},
		handle1:function(id){
			//<router-link :to="{ path: 'dynamic_details', query: { item: {item}}}">
			this.$router.push({ path: 'dynamic_details', query: { id: id }});
		},
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
	div{
		color: white;
	}
</style>
